"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var react_sortable_hoc_1 = require("react-sortable-hoc");
// Relements
var toggle_1 = __importDefault(require("relements/build/esm/input/toggle"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var icon_1 = __importDefault(require("relements/build/esm/ui/icon"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
// Icons
var DragIcon_svg_1 = __importDefault(require("../../icons/DragIcon.svg"));
var ChannelItemWrapper = styled_components_1["default"](box_1["default"])(function (props) { return ({
    backgroundColor: props.isDisabled
        ? props.theme.colors.grey.haptik
        : props.theme.colors.grey.pastel,
    borderRadius: props.theme.radii.sm,
    border: "1px solid " + props.theme.colors.grey.haptik,
    justifyContent: 'space-between',
    padding: 0,
    marginTop: 16,
    zIndex: 1000000009,
    '&.dragging-helper-class': {
        border: "1px solid " + props.theme.colors.blue.haptik,
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.25)',
    },
}); });
var LeftBox = styled_components_1["default"](box_1["default"])({
    margin: 16,
    padding: 0,
    alignItems: 'center',
});
var RightBox = styled_components_1["default"](box_1["default"])({
    margin: '22px 24px',
    padding: 0,
    alignItems: 'center',
});
var ChannelIconWrapper = styled_components_1["default"](icon_1["default"])(function (props) { return ({
    width: 32,
    height: 32,
    filter: props.isDisabled && 'grayscale(1)',
}); });
var Title = styled_components_1["default"](text_1["default"])(function (props) { return ({
    marginLeft: 16,
    color: props.theme.colors.black.haptik,
}); });
var StyledToggle = styled_components_1["default"](toggle_1["default"])(function (props) { return ({
    marginLeft: 16,
    filter: props.disabled ? 'grayscale(1)' : '',
}); });
var StyledDragIcon = styled_components_1["default"](DragIcon_svg_1["default"])({
    cursor: 'pointer',
});
var DragHandle = react_sortable_hoc_1.SortableHandle(function () { return react_1["default"].createElement(StyledDragIcon, null); });
var ChannelItem = function (_a) {
    var type = _a.type, icon = _a.icon, title = _a.title, active = _a.active, onChange = _a.onChange, isDisabled = _a.isDisabled;
    return (react_1["default"].createElement(ChannelItemWrapper, { isDisabled: isDisabled },
        react_1["default"].createElement(LeftBox, null,
            react_1["default"].createElement(ChannelIconWrapper, { src: icon, isDisabled: isDisabled }),
            react_1["default"].createElement(Title, { variant: "h4.semi-bold" }, title)),
        react_1["default"].createElement(RightBox, null,
            react_1["default"].createElement(DragHandle, null),
            react_1["default"].createElement(StyledToggle, { disabled: isDisabled, value: active, onChange: function () { return !isDisabled && onChange(type); } }))));
};
exports["default"] = ChannelItem;
